import { SourceItemType } from "@/src/blocks/converters";
import RelationLink from "@/src/components/RelationLink";

// Editors often enter "youtube.com" without a scheme, which the browser would treat as a relative path
const toAbsoluteUrl = (url: string) => (/^[a-z][a-z\d+.-]*:/i.test(url) ? url : `https://${url}`);

const SourceItem = ({ item }: { item: SourceItemType }) => {
    const link = item.externalLink ? (
        <a href={toAbsoluteUrl(item.externalLink)} target="_blank" rel="noopener noreferrer">
            {item.externalLink}
        </a>
    ) : (
        <RelationLink
            relationTo={item.internalLinkType}
            id={item.internalLinkSlug ?? item.internalLinkId}
            label={item.internalLinkLabel}
        />
    );

    return (
        <div id={`source-${item.id}`}>
            <span>{item.index}. </span>
            <span>{link}</span>
            {item.quote && <span> - {item.quote}</span>}
        </div>
    );
};

/** The numbered sources of a rich text value, as collected by collectSources; renders nothing when empty. */
const SourceList = ({ sources }: { sources: SourceItemType[] }) =>
    sources.length > 0 && (
        <>
            <div>Sources:</div>
            <div>
                {sources.map((s) => (
                    <SourceItem key={s.id} item={s} />
                ))}
            </div>
        </>
    );

export default SourceList;
